/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { countryIdGet } from '../fn/country/country-id-get';
import { CountryIdGet$Params } from '../fn/country/country-id-get';
import { CountryModel } from '../models/country-model';
import { CountryModelSearchResultModel } from '../models/country-model-search-result-model';
import { countryPost } from '../fn/country/country-post';
import { CountryPost$Params } from '../fn/country/country-post';
import { countrySearchCountryPost } from '../fn/country/country-search-country-post';
import { CountrySearchCountryPost$Params } from '../fn/country/country-search-country-post';

@Injectable({ providedIn: 'root' })
export class MDICountryService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `countrySearchCountryPost()` */
  static readonly CountrySearchCountryPostPath = '/Country/SearchCountry';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countrySearchCountryPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  countrySearchCountryPost$Response(params?: CountrySearchCountryPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<CountryModelSearchResultModel>> {
    return countrySearchCountryPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `countrySearchCountryPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  countrySearchCountryPost(params?: CountrySearchCountryPost$Params, context?: HttpContext): Observable<CountryModelSearchResultModel> {
    return this.countrySearchCountryPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<CountryModelSearchResultModel>): CountryModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `countryIdGet()` */
  static readonly CountryIdGetPath = '/Country/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countryIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryIdGet$Response(params: CountryIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<CountryModel>> {
    return countryIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `countryIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  countryIdGet(params: CountryIdGet$Params, context?: HttpContext): Observable<CountryModel> {
    return this.countryIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<CountryModel>): CountryModel => r.body)
    );
  }

  /** Path part for operation `countryPost()` */
  static readonly CountryPostPath = '/Country';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `countryPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  countryPost$Response(params?: CountryPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return countryPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `countryPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  countryPost(params?: CountryPost$Params, context?: HttpContext): Observable<string> {
    return this.countryPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
